<template>
    <div>
        <b-navbar toggleable="lg" type="dark" variant="dark" fixed="top">
            <div class="container">
                <b-navbar-brand class="nav-link" href="#inicio">
                    <span class="d-none d-sm-inline"
                        >Dra. Vívia Linhares Mesquita - Neurologista</span
                    >
                    <span class="d-sm-none">
                        Dra. Vívia Linhares - Neurologista
                        <span class="crm">CRM/CE: 13293 RQE: 7869</span>
                    </span>
                </b-navbar-brand>

                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                <b-collapse id="nav-collapse" is-nav>
                    <b-navbar-nav>
                        <b-nav-item class="nav-link" href="#especialidades"
                            >Especialidades</b-nav-item
                        >
                        <b-nav-item class="nav-link" href="#formacao"
                            >Formação</b-nav-item
                        >
                        <b-nav-item class="nav-link" href="#contato"
                            >Contato</b-nav-item
                        >
                    </b-navbar-nav>
                </b-collapse>
            </div>
        </b-navbar>
    </div>
</template>

<script>
export default {
    name: 'MainMenubar',
}
</script>

<style scoped>
.crm {
    font-size: 9px;
    position: absolute;
    top: 38px;
    left: 40px;
    font-style: italic;
    color: darkgray;
}
</style>
